// Investor Tracker action types

export const LIST_INVESTOR_TRACKER = 'LIST_INVESTOR_TRACKER';
export const STORE_INVESTOR_TRACKER = 'STORE_INVESTOR_TRACKER';

export const STORE_LOCATION = 'STORE_LOCATION';
export const REMOVE_LOCATION = 'REMOVE_LOCATION';
export const STORE_PERSON = 'STORE_PERSON';
export const REMOVE_PERSON = 'REMOVE_PERSON';

export const SAVE_LOCATION = 'SAVE_LOCATION';
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const SAVE_PERSON = 'SAVE_PERSON';
export const DELETE_PERSON = 'DELETE_PERSON';
export const SAVE_EXPENSE = 'SAVE_EXPENSE';
export const DELETE_EXPENSE = 'DELETE_EXPENSE';
export const SAVE_PAYMENT = 'SAVE_PAYMENT';
export const DELETE_PAYMENT = 'DELETE_PAYMENT';
export const UPDATE_PAYMENT_STATUS = 'UPDATE_PAYMENT_STATUS';
export const UPDATE_PARTICIPATION = 'UPDATE_PARTICIPATION';
export const SAVE_CONTRACTOR = 'SAVE_CONTRACTOR';
export const DELETE_CONTRACTOR = 'DELETE_CONTRACTOR';
export const SAVE_QUOTE = 'SAVE_QUOTE';
export const DELETE_QUOTE = 'DELETE_QUOTE';
export const SAVE_CONTRACTOR_PAYMENT = 'SAVE_CONTRACTOR_PAYMENT';
export const DELETE_CONTRACTOR_PAYMENT = 'DELETE_CONTRACTOR_PAYMENT';
export const SAVE_WEEKLY_PAYMENT = 'SAVE_WEEKLY_PAYMENT';
